import { render, staticRenderFns } from "./ModelWithLogos.vue?vue&type=template&id=d3c33fcc&scoped=true&"
import script from "./ModelWithLogos.vue?vue&type=script&lang=js&"
export * from "./ModelWithLogos.vue?vue&type=script&lang=js&"
import style0 from "./ModelWithLogos.vue?vue&type=style&index=0&id=d3c33fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c33fcc",
  null
  
)

export default component.exports